export const handleLocalStorageChangesOnNavBarClick = () => {
  localStorage.setItem("currentSiteBreadcrumbs", JSON.stringify([]));
};
